import React, { Fragment, useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { WfxLogoBlackOnWhite } from '../../utility/SVGUtility'
import { useNavigate, useLocation } from 'react-router-dom'
import { Container, InputAdornment, TextField } from '@mui/material'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import { AppContext } from '../../App'
import Dropdown from '../../views/Dropdown'
import ReactGA from 'react-ga4'

const MenuStyles = styled.span`
  @media (min-width: 0px) and (max-width: 901px){
    
  };
  @media (min-width: 901px) {
    display : none
  };
`

const HeaderTabs = styled.div`
    display:flex;
    flex-direction: row;
    flex: none;
    order: 0;
    flex-grow: 0;
    & > svg {
        height: 25px;
        width: 100px;
        margin: 0vw 10px;
    }
    @media (min-width: 0px) and (max-width: 900px) {
        display: none;
    };
    marginLeft: 10px;
`

const Tab = styled.div`
    color: #FFFFFF;
    font-family: 'AeonikPro-Regular';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-left: 48px;
    cursor: pointer
`
const containerStyles = {
  paddingLeft: '5%',
  paddingRight: '0px',
  margin: '0px',
  backgroundColor: '#25233B',
  display: 'flex',
  alignItems: 'center',
  minHeight: '70px',
  justifyContent: 'space-between',

  '@media (min-width: 1201px)': {
    // Overriding media query for mui component
    width: '100%',
    maxWidth: '100%',
    minWidth: '1200px',
    paddingLeft: '10%',
    paddingRight: '8%'
  },
  '@media (min-width: 361px) and (max-width: 767px)': {
    // Overriding media query for mui component
    width: '100%',
    maxWidth: '100%'
  },
  '@media (min-width: 0px) and (max-width: 360px)': {
    minwidth: '360px',
    maxWidth: '360px',
    paddingLeft: '5%',
    paddingRight: '0px'
  },

  '@media (min-width: 1350px)': {
    width: '1296px',
    maxWidth: '1296px',
    height: '88px',
    margin: 'auto',
    justifyContent: 'space-between',
    alignItem: 'center',
    padding: '0px'

  }

}

const searhContainer = {
  backgroundColor: '#25233B',
  height: '65px',

  '@media (min-width: 901px)': {
    display: 'none'
  }
}

const Logo = styled.span`
  cursor: pointer;
  margin-left: 10px;
`

const Header = () => {
  const navigate = useNavigate()
  const { setSearchTerm } = useContext(AppContext)
  const { searchInput, setSearchInput } = useContext(AppContext)
  const { showSearch, setShowSearch } = useContext(AppContext)
  const [showMinSearch, setShowMinSearch] = useState(false)

  const seachstyle = {
    backgroundColor: 'white',
    borderRadius: '5px',
    '@media (min-width: 0px) and (max-width: 450px)': {
      display: showMinSearch ? '' : 'none',
      top: '50px',
      width: '91%',
      position: 'absolute'
    },
    '@media (min-width: 451px) and (max-width: 900px)': {
      display: showMinSearch ? '' : 'none',
      top: '50px',
      width: '91%',
      position: 'absolute',
      marginRight: '20px'
    },
    '@media (min-width: 901px) ': {
      display: 'flex',
      width: 'inherit',
      marginLeft: '20px',
      borderRadius: '7px'
    }
  }

  const search = () => {
    setSearchTerm(searchInput)
    setShowSearch(true)
    navigate('/')
  }

  const routeToHome = () => {
    setSearchTerm('')
    setShowSearch(false)
    setSearchInput('')
    navigate('/')
  }

  interface KeyboardEvent {
    key: string;
  }

  const handleEnter = (event : KeyboardEvent) => {
    if (event.key === 'Enter') {
      search()
    }
  }

  const location = useLocation()
  useEffect(() => {
    if (!(location.pathname.indexOf('getInTouch') === 1 || location.pathname.indexOf('details') === 1)) {
      setShowSearch(false)
      setShowMinSearch(false)
    } else {
      setShowSearch(true)
      setShowMinSearch(true)
    }
    ReactGA.send({ hitType: 'pageview', page: location.pathname })
  }, [location])

  return (
    <Fragment>
    <Container sx={containerStyles}>
      <Logo onClick={routeToHome}>
        <WfxLogoBlackOnWhite />
      </Logo>
      {showSearch && <TextField sx ={seachstyle}
          margin="normal"
          variant="outlined"
          placeholder={'Search'}
          size="small"
          InputProps={{
            type: 'search',
            endAdornment: (
              <InputAdornment position="start" style={{ color: '#64748B', cursor: 'pointer', paddingLeft: '16px', paddingTop: '4px' }}>
                <SearchOutlinedIcon onClick={() => { search() }} />
              </InputAdornment>
            )
          }}
          inputProps={{
            maxLength: 50
          }}
          value = {searchInput}
          onKeyDown={handleEnter}
          onChange={(event) => setSearchInput(event.target.value)}
        />}
        <MenuStyles>
          <Dropdown />
        </MenuStyles>

      <HeaderTabs>
          <Tab><span style={{ cursor: 'auto' }}>Go to</span> <a target = "_blank"style={{ color: '#ef6413' }}href='https://whatfix.com/' rel="noreferrer">whatfix.com</a></Tab>
          <Tab onClick={() => navigate('/getInTouch')}>Contact Us</Tab>
      </HeaderTabs>
    </Container>
    {showMinSearch && <Container sx={searhContainer}>
    </Container>}
    </Fragment>
  )
}

export default Header
